import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, Button, Hidden, Tooltip } from "@material-ui/core";
import TeacherSidebar from "../../../TeacherSidebar/TeacherSidebar";
import TeacherSidebarTile from "../../../TeacherSidebar/TeacherSidebarTile";
import NewClassModal from "../../../Modals/NewClassModal";
import useModal from "../../../Modals/UseModal";
import ModalSize from "../../../Modals/ModalSize";
import { RootState } from "../../../../state/configureStore";
import add from "../../../../assets/icons/noun_Plus_2190.png";
import "../../../TeacherSidebar/TeacherSidebar.css";
import Loading from "../../../Loading/Loading";

const TeacherHomeScreenSidebar = () => {
  const [expanded, setExpanded] = React.useState("");
  const profile = useSelector((state: RootState) => state.currentUserState.currentUser);
  const classrooms = useSelector((state: RootState) => state.teacherState.classrooms);
  const handleChange = (panel: string) => (_ev: unknown, isExpanded: boolean) => setExpanded(isExpanded ? panel : "");
  const { open, openModal, closeModal } = useModal(false);

  if (!profile) return <Loading />;
  return (
    <TeacherSidebar
      header={
        <h1 className="WelcomeName" title={profile.firstName}>
          Welcome, {profile.firstName}!
        </h1>
      }
    >
      <div className="accordionLinks">
        <Accordion
          square
          elevation={0}
          expanded={expanded === "students"}
          onChange={handleChange("students")}
          style={{ margin: "0 0" }}
        >
          <AccordionSummary className="accordionTitle">Students</AccordionSummary>
          <Button
            className="newBtn"
            onClick={openModal}
            style={{
              textTransform: "none",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img style={{ color: "#FC6954" }} height={17} color="#FC6954" src={add} alt="+" />
            <div
              style={{
                color: "#FC6954",
                fontWeight: "bold",
                marginTop: "2px",
                marginLeft: "2px",
                fontSize: "15.5px",
              }}
            >
              New Class
            </div>
          </Button>
          {classrooms &&
            classrooms.map(classroom => (
              <TeacherSidebarTile
                classId={classroom.id}
                className={classroom.className || ""}
                grade={classroom.grade || ""}
                key={classroom.id}
              />
            ))}
        </Accordion>
        <Accordion
          square
          elevation={0}
          expanded={expanded === "assignments"}
          onChange={handleChange("assignments")}
          style={{ margin: "0 0" }}
        >
          <AccordionSummary className="accordionTitle">Assignments</AccordionSummary>
          <Button
            className="newBtn"
            href="/teacher/#/assignmentSelection"
            style={{
              textTransform: "none",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img style={{ color: "#FC6954" }} height={17} color="#FC6954" src={add} alt="+" />
            <div
              style={{
                color: "#FC6954",
                fontWeight: "bold",
                marginTop: "2px",
                marginLeft: "2px",
                fontSize: "15.5px",
              }}
            >
              New Assignment
            </div>
          </Button>
          <NavLink to={"/Assignments"} className="navLink">
            <AccordionDetails>All Assignments</AccordionDetails>
          </NavLink>
          <NavLink to="/Assignments?filterBy=starred" className="navLink">
            <AccordionDetails>Starred</AccordionDetails>
          </NavLink>
          <NavLink to="/Assignments?filterBy=shared" className="navLink">
            <AccordionDetails>Shared With Me</AccordionDetails>
          </NavLink>
          <NavLink to="/Assignments?filterBy=archived" className="navLink">
            <AccordionDetails>Archived</AccordionDetails>
          </NavLink>
        </Accordion>
        <div className="helpLinks">
          <Tooltip title="Our Content Library is unavailable as we transition to our new application">
            <span className="contentLibrary">Content Library</span>
          </Tooltip>
        </div>
        <Hidden xsDown>
          <NewClassModal size={ModalSize.large} open={open} cancelClose={closeModal} />
        </Hidden>
        <Hidden smUp>
          <NewClassModal size={ModalSize.extraSmall} open={open} cancelClose={closeModal} />
        </Hidden>
      </div>
    </TeacherSidebar>
  );
};

export default TeacherHomeScreenSidebar;
